/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Players_Edit_TossInputs */



/**
* | output |
* | --- |
* | "Edit toss" |
*
* @param {Players_Edit_TossInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const players_edit_toss = /** @type {((inputs?: Players_Edit_TossInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Players_Edit_TossInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifier le toss")
	if (locale === "es") return /** @type {LocalizedString} */ ("Editar toss")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Editar toss")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modifica toss")
	return /** @type {LocalizedString} */ ("Edit toss")
});